import { forwardRef, useEffect, useState } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  Stack,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  setApproveDialog,
  LeaveAdmin,
} from "../../../../app/slices/leaveAdminSlice";
import { LeaveStatus } from "../../../../app/slices/leaveStatusSlice";
import { SelectLeaveStatus } from "../../../../components/Selectors/SelectLeaveStatus";
import { findStatusByKind } from "../../leaveStatus";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LeaveApproveForm = () => {
  const dispatch = useDispatch();

  const _Approve = useSelector((state) => state.leaveAdmin.approve);
  const _SearchBody = useSelector((state) => state.leaveAdmin.searchBody);
  const statusList = useSelector((state) => state.leaveStatus.data);

  const [status, setStatus] = useState(null);
  const [comments, setcomments] = useState("");

  const row = _Approve.data;

  useEffect(() => {
    if (!statusList?.length) {
      dispatch(LeaveStatus.getAll());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // The button the admin pressed picks the status, but it stays editable in
  // case the list from the API does not match the expected wording.
  useEffect(() => {
    setStatus(findStatusByKind(statusList, _Approve.kind));
  }, [statusList, _Approve.kind]);

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(
      LeaveAdmin.approve(
        row?.id,
        {
          status_id: status?.id,
          comments: comments,
        },
        _SearchBody,
      ),
    );
  };

  return (
    <Dialog
      open={_Approve.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      maxWidth="sm"
      dir="rtl"
      onClose={() => dispatch(setApproveDialog())}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <Typography
          mb={1}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          تدقيق طلب الاجازة
        </Typography>
        <Stack direction="column" spacing={0.5} mb={3}>
          <Typography variant="body2" color="text.secondary">
            المندوب: {row?.user_name ?? ""}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            من {row?.start_date ? dayjs(row.start_date).format("YYYY-MM-DD") : ""}{" "}
            الى {row?.end_date ? dayjs(row.end_date).format("YYYY-MM-DD") : ""} -
            عدد الايام: {row?.total_days ?? ""}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            السبب: {row?.reason ?? ""}
          </Typography>
        </Stack>
        <form onSubmit={onSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SelectLeaveStatus
                required
                label="حالة الطلب"
                value={status}
                onChange={(e, newValue) => setStatus(newValue ?? null)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                size="small"
                label="الملاحظات"
                multiline
                rows={3}
                fullWidth
                value={comments}
                onChange={(e) => setcomments(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={!status}
              >
                حفظ
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default LeaveApproveForm;
